<template>
    <footer class="container">
        <div
            class="bg-black text-white p-4 sm:p-8 lg:px-0 lg:py-16 rounded-3xl"
        >
            <div class="md:grid md:grid-cols-3 flex flex-col lg:w-3/4 mx-auto">
                <div>
                    <Link
                        class="flex flex-start flex-shrink-0 pr-7 md:mb-0 mb-7"
                        href="/"
                    >
                        <img
                            src="/img/yoda.svg"
                            class="img-fluid pr-5"
                            alt="logo"
                            title="logo"
                        />
                        <span class="mb-auto">Yoda Mentorship</span>
                    </Link>
                </div>
                <div>
                    <ul>
                        <li class="text-white font-bold uppercase text-sm mb-5">
                            Sledujte nás
                        </li>
                        <li><a href="https://www.facebook.com/yodamentorship" target="_blank" class="border-b">Facebook</a></li>
                        <li><a href="https://www.instagram.com/yoda.mentorship/?hl=cs" target="_blank" class="border-b">Instagram</a></li>
                        <!-- <li><a href="https://twitter.com/YodaMentorship" target="_blank" class="border-b">Twitter</a></li> -->
                        <li><a href="https://cz.linkedin.com/company/yoda-mentorship-programme" target="_blank" class="border-b">LinkedIn</a></li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li
                            class="
                                text-white
                                font-bold
                                uppercase
                                text-sm
                                md:mt-0
                                mt-5
                                mb-5
                            "
                        >
                            Navigace
                        </li>
                        <li>
                            <Link href="/o-nas" class="hover:underline">O nás</Link>
                        </li>
                        <li>
                            <Link href="/mentori" class="hover:underline">Mentoři</Link>
                        </li>
                        <li>
                            <Link href="/blog" class="hover:underline">Blog</Link>
                        </li>
                        <li>
                            <Link href="/kontakt" class="hover:underline">Kontakt</Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="lg:w-3/4 mx-auto mt-8">
                <p>© Yoda mentorship, 2017 - {{ new Date().getFullYear() }}</p>
            </div>
        </div>
    </footer>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
    components: {
        Link,
    },
}
</script>
